import * as React from 'react';
import { useContext, useEffect, useState } from 'react';
import { Language } from 'src/utils/Languages';

type Api = {
    app?: AppDto;
    get: (path: string) => Promise<IPageDto>;
    loading: boolean;
};

export const ApiContext = React.createContext<Api>({} as never);

type Props =  {};
export const Api: React.FC<Props> = ({ children }) => {

    const [appDto, setAppDto] = useState<AppDto>();
    const [loading, setLoading] = useState(false);
    const [pageLoading, setPageLoading] = useState(false);
    const [appLoading, setAppLoading] = useState(false);

    useEffect(() => {
        if (!appDto) {
          fetchApp()
            .then(app => {
                setAppDto(app)
            })
        }
      }, []);

    const fetchPage = async (path: string): Promise<IPageDto> => {
        const requestOptions: RequestInit = {
            method: 'GET',
            headers: {
                'Accept-Language': Language,
                'Content-Type': 'application/json'
            }
        };

        setAppLoading(true);
        setPageLoading(true);

        return fetch(`${path}?json`, requestOptions)
            .then(response => {
                return response.json();
            })
            .then(pageDto => {
                setLoading(false);
                setAppLoading(pageLoading);
                return pageDto
            })
            .catch(() => {
                setLoading(false);
                setAppLoading(pageLoading);
            });
    }

    const fetchApp = async (): Promise<AppDto> => {
        const requestOptions: RequestInit = {
            method: 'GET',
            headers: {
                'Accept-Language': Language,
                'Content-Type': 'application/json'
            }
        };

        setAppLoading(true);
        setLoading(true);

        return fetch(`/${Language}/api/app`, requestOptions)
            .then(response => {
                return response
                    .json();
            })
            .then(appJson => {
                setLoading(false);
                setPageLoading(appLoading);
                return appJson;
            })
            .catch(() => {
                setLoading(false);
                setPageLoading(appLoading);
            });
    }

    return (
        <ApiContext.Provider value={{ app: appDto, get: fetchPage, loading }}>
            {children}
        </ApiContext.Provider>
    );
};

export const useApi = () => useContext(ApiContext);


// WEBPACK FOOTER //
// ./src/@context/Api.tsx